'use client';

import { useTranslations } from 'next-intl';
import { ServerActionName } from '@headless-workspace/config';
import {
    AsyncData,
    ContentAssetKeys,
    ResultEmpty,
    ResultFailure,
    ResultSuccess,
} from '@headless-workspace/core-domain';
import { useClientData, UserRevalidationKey, useSafeSWR } from '../../../client';
import { ContentAssetType, getContentAssetServerAction } from '../../../server';

const ASSET_ERROR_NOT_FOUND = 'NOT_FOUND';

export const useNotifyMeAssets = (): AsyncData<ContentAssetType[]> => {
    const t = useTranslations('Common.contentAssets');

    const { getContentAssets } = useClientData();

    const notifyMeContentAssetHeader = getContentAssets(ContentAssetKeys.NotifyMeHeaderText);
    const notifyMeContentAssetChartProtect = getContentAssets(ContentAssetKeys.NotifyMeChartProtectText);
    const notifyMeContentAssetConfirmation = getContentAssets(ContentAssetKeys.NotifyMeConfirmationText);

    const haveFoundContentAsset = !!(
        notifyMeContentAssetHeader?.id &&
        notifyMeContentAssetChartProtect?.id &&
        notifyMeContentAssetConfirmation?.id
    );

    const {
        data: swrData,
        isLoading,
        error,
    } = useSafeSWR(
        haveFoundContentAsset ? null : UserRevalidationKey.NotifyMeAsset,
        ServerActionName.getContentAssetServerAction,
        () =>
            getContentAssetServerAction([
                ContentAssetKeys.NotifyMeHeaderText,
                ContentAssetKeys.NotifyMeChartProtectText,
                ContentAssetKeys.NotifyMeConfirmationText,
            ]),
    );

    if (haveFoundContentAsset) {
        return {
            isLoading: false,
            result: ResultSuccess([
                notifyMeContentAssetHeader,
                notifyMeContentAssetChartProtect,
                notifyMeContentAssetConfirmation,
            ]),
        };
    }
    if (swrData?.type !== 'success' || swrData.data.length === 0) {
        if (error) {
            return {
                isLoading,
                result: ResultFailure(
                    ASSET_ERROR_NOT_FOUND,
                    error instanceof Error ? error.message : t('toast.error.assetNotFound'),
                ),
            };
        }
        return { isLoading, result: ResultEmpty() };
    }
    return { isLoading: false, result: swrData };
};
